module.exports = function() {
  return new Worker(__webpack_public_path__ + "b898199c77b935089e6c.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/build/pdf.worker.js
// module id = 1040
// module chunks = 2